import React from 'react';

import playlistCustomers from 'maps/customer-name-id';

import CustomerIcon from 'components/base/CustomerIcon/CustomerIcon';

import {
  Cell,
  DSPEntityMeta,
  RowWrapper,
} from '../../../FAQActivityTracker.styles';

interface IRowProps {
  customerName: string;
  displayName: string;
  customerId: number;
}

const Row: React.FC<IRowProps> = (props) => {
  const { customerName, displayName, customerId } = props;

  const playlistCustomerId = Object.keys(playlistCustomers).find(
    (key) => playlistCustomers[key] === customerId
  );

  return (
    <RowWrapper>
      <Cell>{displayName}</Cell>
      <Cell width={'40px'}>
        <CustomerIcon showHiddenPlaceholder customer={playlistCustomerId} />
        <DSPEntityMeta>{customerName}</DSPEntityMeta>
      </Cell>
    </RowWrapper>
  );
};

export default Row;
